import { useAdminRequestScope } from "./useAdminRequestScope";
import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import type { Notify, RoleRow } from "./admin-types";

export function useAdminRolesWorkspace({notify}: {notify: Notify}) {
  const scope = useAdminRequestScope(notify);
  const [rows, setRows] = useState<RoleRow[]>([]);
  const load = useCallback(() => {
    if (!scope.isMounted()) return;
    const request = scope.beginRead();
    void apiRequest<RoleRow[]>("/api/admin/roles").then(value => {
      if (scope.isCurrentRead(request)) setRows(value);
    }).catch((error: unknown) => {
      if (scope.isCurrentRead(request)) scope.notify(error instanceof Error ? error.message : "Roller alınamadı.");
    });
  }, [scope]);
  useEffect(load, [load]);
  return { rows };
}
